import { NavItem } from '../layouts/full/vertical/sidebar/nav-item/nav-item';

/**
 * Filters sidebar nav items by Auth0 scopes (collection-suite / amber-debi-check pattern).
 * Does not mutate the source array.
 * Amber Setup SideNav scope filter. 18/09/2026 CN
 */
export function filterNavItemsByScopes(
  items: NavItem[],
  userHasScopes: (scopes: string[]) => boolean
): NavItem[] {
  const filtered = items
    .map((item) => {
      const clone: NavItem = { ...item };
      if (item.children?.length) {
        clone.children = filterNavItemsByScopes(item.children, userHasScopes);
      }
      return clone;
    })
    .filter((item) => {
      if (item.expectedScopes !== undefined && !userHasScopes(item.expectedScopes)) {
        return false;
      }
      // Hide parents whose children were all filtered out
      if (item.children !== undefined && item.children.length === 0) {
        return false;
      }
      return true;
    });

  return stripOrphanNavCaps(filtered);
}

/** Remove section headers (navCap-only) that have no following visible items. */
function stripOrphanNavCaps(items: NavItem[]): NavItem[] {
  const result: NavItem[] = [];
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const isCapOnly = !!item.navCap && !item.displayName && !item.route && !item.children?.length;
    if (isCapOnly) {
      const next = items[i + 1];
      if (!next || (!!next.navCap && !next.displayName && !next.route)) {
        continue;
      }
    }
    result.push(item);
  }
  return result;
}
